module.exports = "/3068/img/adblock-cover-big.e380633b.png";